import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/master/selling/RentalRates'

export default {
  async getAll(filter) {
    return await axios
      .get(endpoint + `/list${filter}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getRates(masterClassId, isSelfDrive) {
    return await axios
      .get(endpoint + `/list/rate?class=${masterClassId}&selfDrive=${isSelfDrive}`)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getBuyingRange(masterClassId, isSelfDrive) {
    return await axios
      .get(endpoint + `/list/range?class=${masterClassId}&selfDrive=${isSelfDrive}`)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getCommon(isSelfDrive) {
    return await axios
      .get(endpoint + `/common?selfDrive=${isSelfDrive}`)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async create(request) {
    return await axios
      .post(endpoint, request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async update(request) {
    return await axios
      .put(endpoint, request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async delete(id) {
    return await axios
      .delete(endpoint + `/${id}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/master/sellingTariff/sellingTariffRentalRateService.js